import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder, getTicketTypeById, getCountries } from "ticketino-api-client";

import imgIconProgressCompleted from "../images/progress-bar/ball-completed.svg";
import imgIconProgress from "../images/progress-bar/ball-progress.svg";

import imgIconInfo from "../images/icons/info.svg";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

const Address = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [tickets, setTickets] = useState([]);
    const [organizerId, setOrganizerId] = useState(0);
    const [promotioncode] = useState(sessionStorage.getItem("addedPromotion"));
    const [selectedTicketTypeId] = useState(sessionStorage.getItem("selectedTicketTypeId"));
    const [countSaturdayTickets] = useState(sessionStorage.getItem("countSaturdayTickets"));
    const [countSundayTickets] = useState(sessionStorage.getItem("countSundayTickets"));

    const [isError, setIsError] = useState(false);

    const [loading, setLoading] = useState(false);

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        street: "",
        city: "",
        postCode: "",
        countryId: 176,
        email: "",
        confirmemail: "",
        code1: "" //where did you hear
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [countries, setCountries] = useState([]);

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }


        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId)
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate(`/${language}/home`);
                }

                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
        loadCountries();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const removePromotionCode = async (promotion) => {
        try {
            const response = axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotion}`);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const loadCountries = async () => {
        try {
            let countries = await getCountries(language);

            const indexCH = countries.findIndex(c => c.id === 176);
            const ch = countries[indexCH];
            countries.splice(indexCH, 1);

            var indexDE = countries.findIndex(c => c.id === 229);
            const de = countries[indexDE];
            countries.splice(indexDE, 1);

            var indexAU = countries.findIndex(c => c.id === 228);
            const au = countries[indexAU];
            countries.splice(indexAU, 1);

            var indexFR = countries.findIndex(c => c.id === 59);
            const fr = countries[indexFR];
            countries.splice(indexFR, 1);

            var indexIT = countries.findIndex(c => c.id === 87);
            const it = countries[indexIT];
            countries.splice(indexIT, 1);

            countries.unshift({ id: 0, name: "---------" });
            countries.unshift(it);
            countries.unshift(au);
            countries.unshift(fr);
            countries.unshift(de);
            countries.unshift(ch);

            setCountries(countries);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate(`/${language}/home`);
            }
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            // Check if updatedOrder or tickets is falsy before continuing
            if (!updatedOrder || !updatedOrder.tickets || updatedOrder.tickets.length === 0) {
                navigate(`/${language}/home`);
                return; // stop further execution
            }

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);
                    return { ...ticket, ticketType: ticketType }
                })
            );

            setTickets(updatedTickets);
            setOrder(updatedOrder);

            //const address = await getAddressOfOrder(orderId);
            //setBuyerInfo({
            //    ...buyerInfo,
            //    ...address,
            //    confirmemail: address.email
            //});
        }
        catch (error) {
            console.error(error);
        }
    };


    const onInputChange = (e) => {
        setBuyerInfo({ ...buyerInfo, [e.target.name]: e.target.value });
    };

    const onSubmit = async () => {
        const isValid = validateInputFields();

        if (!isValid) return;

        setLoading(true);

        await addAddressToBasket(buyerInfo.companion1firstname, buyerInfo.companion1lasttname);
    }

    const addAddressToBasket = async () => {

        let emailSalutation = buyerInfo.salutation;

        //workaround for german email salutation
        if (emailSalutation === "Herr") {
            emailSalutation = resources?.BuyerSalutationMrValue;
        } else if (emailSalutation === "Frau") {
            emailSalutation = resources?.BuyerSalutationMsValue;
        } else if (emailSalutation === "Divers") {
            emailSalutation = resources?.BuyerSalutationDiverseValue;
        }

        let addressBody = {
            salutation: buyerInfo.salutation,
            firstName: buyerInfo.firstName,
            name: buyerInfo.name,
            street: buyerInfo.street,
            city: buyerInfo.city,
            postCode: buyerInfo.postCode,
            countryId: buyerInfo.countryId,
            email: buyerInfo.email,
            code1: buyerInfo.code1,
            code3: emailSalutation
        };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {

                // gtm - addAddress
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addAddress'
                });

                // Check if all tickets have no additionalFields or empty additionalFields array
                const noAdditionalFields = tickets?.every(
                    (t) => !t.ticketType?.additionalFields || t.ticketType.additionalFields.length === 0
                );

                if (noAdditionalFields) {
                    navigate(`/${language}/overview`);
                    return;
                } else {
                    navigate(`/${language}/workshop-ticket`)
                }
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/home`)
            });
    };

    const validateInputFields = () => {

        let validation =
            buyerInfo.firstName && /^.{1,70}$/.test(buyerInfo.firstName) &&
            buyerInfo.name && /^.{1,70}$/.test(buyerInfo.name) &&
            buyerInfo.postCode && /^.{1,70}$/.test(buyerInfo.postCode) &&
            buyerInfo.city && /^.{1,70}$/.test(buyerInfo.city) &&
            buyerInfo.code1 && /^.{1,70}$/.test(buyerInfo.code1) &&
            buyerInfo.email && /^\S+@\S+\.\S+$/.test(buyerInfo.email) &&
            buyerInfo.confirmemail && /^\S+@\S+\.\S+$/.test(buyerInfo.confirmemail) &&
            buyerInfo.email === buyerInfo.confirmemail;

        setIsError(!validation);
        return validation;

    }

    const onBackClick = async () => {
        navigate(-1)
    }

    return (
        <>
            {loading ? (
                <>
                    <Loading
                        alignment="center"
                        color="#d3d3d3"
                        bgColor="transparent"
                        top="50%"
                        resources={resources}
                    />
                </>
            ) : (
                <>
                    <Header language={language} pagePath="address" />
                    <div className="page-container">

                        {/* progress bar */}
                        <div className="progressbar-wrapper">
                            <div className="progressbar-lines">
                                <div className="line" />
                                <div className="line" />
                                <div className="line" />
                            </div>

                            <div className="progressbar-steps">
                                <div className="progress-step completed cursor-pointer" onClick={() => navigate(`/${language}/home`)}>
                                    <div className="circle">
                                        <img src={imgIconProgressCompleted} alt="Step 1" />
                                    </div>
                                    <div className="label">{resources?.ProgressTickets}</div>
                                </div>

                                <div className={`progress-step completed${countSaturdayTickets > 0 || countSundayTickets > 0 ? " cursor-pointer" : ""}`} onClick={() => {
                                    if (countSaturdayTickets > 0) {
                                        navigate(`/${language}/workshops-saturday`);
                                    } else if (countSundayTickets > 0) {
                                        navigate(`/${language}/workshops-sunday`);
                                    }
                                }}>
                                    <div className="circle">
                                        <img src={imgIconProgressCompleted} alt="Step 2" />
                                    </div>
                                    <div className="label">
                                        {resources?.ProgressWorkshops}<br />{resources?.ProgressOptional}
                                    </div>
                                </div>

                                <div className="progress-step active">
                                    <div className="circle">
                                        <img src={imgIconProgressCompleted} alt="Step 3" />
                                    </div>
                                    <div className="label">{resources?.ProgressAdditionalInformation}</div>
                                </div>

                                <div className="progress-step">
                                    <div className="circle">
                                        <img src={imgIconProgress} alt="Step 4" />
                                    </div>
                                    <div className="label">{resources?.ProgressCheckout}</div>
                                </div>
                            </div>
                        </div>

                        <div className="container wrapper">

                            <div className="row fw-bold text-pink mt-5">
                                <div className="d-flex align-items-start">
                                    <img src={imgIconInfo} alt="Increase" width="18" height="18" className="me-2" />
                                    <span>{resources?.BuyerMandatoryFields}</span>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-12">
                                    <span className="text-subtitle">{resources?.BuyerPleaseFill}</span>
                                </div>
                            </div>

                            <div className="tickets-box p-3 mt-4">
                                {/* Buyer */}
                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <select className={`form-select mt-2`} value={buyerInfo.salutation} name="salutation" onChange={onInputChange}>
                                            <option value="">{resources?.BuyerSalutation}</option>
                                            <option value={resources?.BuyerSalutationMr}>{resources?.BuyerSalutationMr}</option>
                                            <option value={resources?.BuyerSalutationMs}>{resources?.BuyerSalutationMs}</option>
                                            {language === "en" && (
                                                <option value="Mrs.">Mrs.</option>
                                            )}
                                            <option value={resources?.BuyerSalutationDiverse}>{resources?.BuyerSalutationDiverse}</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="firstName"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerFirstname}
                                            value={buyerInfo.firstName}
                                            id="firstName"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerLastname}
                                            value={buyerInfo.name}
                                            id="name"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="street"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerStreet}
                                            value={buyerInfo.street}
                                            id="street"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="postCode"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerPostcode}
                                            value={buyerInfo.postCode}
                                            id="postCode"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="city"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerCity}
                                            value={buyerInfo.city}
                                            id="city"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3 row">
                                    <div className="col-md-12">
                                        <div>
                                            <select
                                                className="form-select"
                                                aria-label=""
                                                id="countryId"
                                                name="countryId"
                                                value={buyerInfo.countryId}
                                                onChange={onInputChange}
                                            >
                                                <option value="">{resources?.BuyerCountry}</option>
                                                {
                                                    countries.map((country, index) => (
                                                        <option value={country.id}>{country.name}</option>
                                                    ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerEmail}
                                            value={buyerInfo.email}
                                            id="email"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4 row">
                                    <div className="col-md-12">
                                        <input
                                            type="text"
                                            name="confirmemail"
                                            className="form-control mt-2"
                                            placeholder={resources?.BuyerConfirmEmail}
                                            value={buyerInfo.confirmemail}
                                            id="confirmemail"
                                            onChange={onInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="mb-4 mt-4 row">
                                    <div className="col-md-12">
                                        <select className={`form-select mt-2`} value={buyerInfo.code1} name="code1" onChange={onInputChange}>
                                            <option value="">{resources?.BuyerWhereDidYouHear}</option>
                                            <option value="Instagram">Instagram</option>
                                            <option value="Internet">Internet</option>
                                            <option value={resources?.BuyerFriends}>{resources?.BuyerFriends}</option>
                                            <option value={resources?.BuyerLocalYarnStore}>{resources?.BuyerLocalYarnStore}</option>
                                            <option value="TICKETINO">TICKETINO</option>
                                            <option value={resources?.BuyerOther}>{resources?.BuyerOther}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-6">
                                    <button className="btn btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>
                                </div>
                                <div className="col-6 text-end">
                                    <button className="btn btn-custom" onClick={() => onSubmit()}>{resources?.Next}</button>
                                </div>
                            </div>


                            {isError &&
                                <div className="row text-start mt-2">
                                    <p className="text-error">{resources?.ErrorPleaseFillMandatoryFields}</p>
                                </div>
                            }

                            {buyerInfo.email !== buyerInfo.confirmemail && buyerInfo.confirmemail.length > 0 &&
                                <div className="row">
                                    <div className="col-12 text-end">
                                        <span className="error">{resources?.BuyerErrorPasswordMismatch}</span>
                                    </div>
                                </div>
                            }

                            <div className="row mt-5">
                                <div className="col-md-12 text-center">
                                    <p className="mt-4">
                                        <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <Footer language={language} />
        </>
    )
}

export default Address